import React from "react";
import { PreviewMessageTemplateDrawer } from "../../../Customers/Templates/PreviewMessageTemplateDrawer";
import { EmailDetails } from "@/components/Email/EmailDetails";
import { Loader } from "@/components/Loader";
import { useEmail } from "@/hooks/resources/useEmail";

interface EmailPreviewDrawerProps {
    emailId: ID;
    isOpen: boolean;
    onClose: () => void;
}

export const EmailPreviewDrawer = ({ emailId, isOpen, onClose }: EmailPreviewDrawerProps) => {
    const { email, isLoadingEmail } = useEmail(emailId, {}, { enabled: isOpen });

    return (
        <PreviewMessageTemplateDrawer
            isOpen={isOpen}
            classNames={{ dialog: "z-40", children: "!p-0", content: "mt-0" }}
            onClose={onClose}
        >
            {isLoadingEmail ? (
                <Loader className="py-20" text="Fetching Email" />
            ) : (
                <EmailDetails email={email} showDownloadButton={false} />
            )}
        </PreviewMessageTemplateDrawer>
    );
};
